// Per-user UI/app preferences (geräteübergreifend persistiert via MongoDB).
// Backend: backend/routes/user_preferences_routes.py
//
// Schema is intentionally generic: the server stores an opaque `ui` dict and
// validates each known key against an allow-list. New keys can ship from the
// client without backend changes, but unknown keys are dropped silently.

import getToken from '../auth/getToken';

const API = () => process.env.REACT_APP_BACKEND_URL;
const SCOPE = () => [`${process.env.REACT_APP_CLIENT_ID}/.default`];

async function authHeader(instance) {
  const token = await getToken(instance, SCOPE());
  return { Authorization: `Bearer ${token}` };
}

export async function fetchUserPreferences(instance) {
  const response = await fetch(`${API()}/api/user/preferences`, {
    headers: await authHeader(instance),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data?.error || `HTTP ${response.status}`);
  }
  return response.json(); // { username, ui: {...}, updated_at }
}

/**
 * Patch-merge update. `uiPatch` only needs to contain the keys you want to
 * change; the server preserves all other keys already stored.
 */
export async function updateUserPreferences(instance, uiPatch) {
  const response = await fetch(`${API()}/api/user/preferences`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(await authHeader(instance)),
    },
    body: JSON.stringify({ ui: uiPatch }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || `HTTP ${response.status}`);
  }
  return data;
}
